'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _bluebird = require('bluebird');

var _matrixJsSdk = require('matrix-js-sdk');

var Matrix = _interopRequireWildcard(_matrixJsSdk);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBeautifulDnd = require('react-beautiful-dnd');

var _Keyboard = require('../../Keyboard');

var _PageTypes = require('../../PageTypes');

var _PageTypes2 = _interopRequireDefault(_PageTypes);

var _CallMediaHandler = require('../../CallMediaHandler');

var _CallMediaHandler2 = _interopRequireDefault(_CallMediaHandler);

var _FontManager = require('../../utils/FontManager');

var _index = require('../../index');

var _index2 = _interopRequireDefault(_index);

var _dispatcher = require('../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _SessionStore = require('../../stores/SessionStore');

var _SessionStore2 = _interopRequireDefault(_SessionStore);

var _MatrixClientPeg = require('../../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _SettingsStore = require('../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _RoomListStore = require('../../stores/RoomListStore');

var _RoomListStore2 = _interopRequireDefault(_RoomListStore);

var _pages = require('../../utils/pages');

var _TagOrderActions = require('../../actions/TagOrderActions');

var _TagOrderActions2 = _interopRequireDefault(_TagOrderActions);

var _RoomListActions = require('../../actions/RoomListActions');

var _RoomListActions2 = _interopRequireDefault(_RoomListActions);

var _ResizeHandle = require('../views/elements/ResizeHandle');

var _ResizeHandle2 = _interopRequireDefault(_ResizeHandle);

var _resizer = require('../../resizer');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// We need to fetch each pinned message individually (if we don't already have it)
// so each pinned message may trigger a request. Limit the number per room for sanity.
// NB. this is just for server notices rather than pinned messages in general.
var MAX_PINNED_NOTICES_PER_ROOM = 2;

/**
 * This is what our MatrixChat shows when we are logged in. The precise view is
 * determined by the page_type property.
 *
 * Currently it's very tightly coupled with MatrixChat. We should try to do
 * something about that.
 *
 * Components mounted below us can access the matrix client via the react context.
 */
/*
Copyright 2015, 2016 OpenMarket Ltd
Copyright 2017 Vector Creations Ltd
Copyright 2017, 2018 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var LoggedInView = _react2.default.createClass({
    displayName: 'LoggedInView',

    propTypes: {
        matrixClient: _propTypes2.default.instanceOf(Matrix.MatrixClient).isRequired,
        page_type: _propTypes2.default.string.isRequired,
        onRoomCreated: _propTypes2.default.func,

        // Called with the credentials of a registered user (if they were a ROU that
        // transitioned to PWLU)
        onRegistered: _propTypes2.default.func,
        collapsedRhs: _propTypes2.default.bool,

        // Used by the RoomView to handle joining rooms
        viaServers: _propTypes2.default.arrayOf(_propTypes2.default.string)

        // and lots and lots of other stuff.
    },

    childContextTypes: {
        matrixClient: _propTypes2.default.instanceOf(Matrix.MatrixClient),
        authCache: _propTypes2.default.object
    },

    getChildContext: function getChildContext() {
        return {
            matrixClient: this._matrixClient,
            authCache: {
                auth: {},
                lastUpdate: 0
            }
        };
    },

    getInitialState: function getInitialState() {
        return {
            // use compact timeline view
            useCompactLayout: _SettingsStore2.default.getValue('useCompactLayout'),
            // any currently active server notice events
            serverNoticeEvents: []
        };
    },

    componentDidMount: function componentDidMount() {
        this.resizer = this._createResizer();
        this.resizer.attach();
        this._loadResizerPreferences();
    },

    componentWillMount: function componentWillMount() {
        // stash the MatrixClient in case we log out before we are unmounted
        this._matrixClient = this.props.matrixClient;

        _CallMediaHandler2.default.loadDevices();

        document.addEventListener('keydown', this._onKeyDown);

        this._sessionStore = _SessionStore2.default;
        this._sessionStoreToken = this._sessionStore.addListener(this._setStateFromSessionStore);
        this._setStateFromSessionStore();

        this._updateServerNoticeEvents();

        this._matrixClient.on("accountData", this.onAccountData);
        this._matrixClient.on("sync", this.onSync);
        this._matrixClient.on("RoomState.events", this.onRoomStateEvents);

        (0, _FontManager.fixupColorFonts)();
    },

    componentDidUpdate: function componentDidUpdate(prevProps) {
        // attempt to guess when a banner was opened or closed
        if (prevProps.showCookieBar !== this.props.showCookieBar || prevProps.hasNewVersion !== this.props.hasNewVersion || prevProps.userHasGeneratedPassword !== this.props.userHasGeneratedPassword || prevProps.showNotifierToolbar !== this.props.showNotifierToolbar) {
            this.props.resizeNotifier.notifyBannersChanged();
        }
    },


    componentWillUnmount: function componentWillUnmount() {
        document.removeEventListener('keydown', this._onKeyDown);
        this._matrixClient.removeListener("accountData", this.onAccountData);
        this._matrixClient.removeListener("sync", this.onSync);
        this._matrixClient.removeListener("RoomState.events", this.onRoomStateEvents);
        if (this._sessionStoreToken) {
            this._sessionStoreToken.remove();
        }
        this.resizer.detach();
    },

    // Child components assume that the client peg will not be null, so give them some
    // sort of assurance here by only allowing a re-render if the client is truthy.
    //
    // This is required because `LoggedInView` maintains its own state and if this state
    // updates after the client peg has been made null (during logout), then it will
    // attempt to re-render and the children will throw errors.
    shouldComponentUpdate: function shouldComponentUpdate() {
        return Boolean(_MatrixClientPeg2.default.get());
    },

    canResetTimelineInRoom: function canResetTimelineInRoom(roomId) {
        if (!this.refs.roomView) {
            return true;
        }
        return this.refs.roomView.canResetTimeline();
    },

    _setStateFromSessionStore: function _setStateFromSessionStore() {
        this.setState({
            userHasGeneratedPassword: Boolean(this._sessionStore.getCachedPassword())
        });
    },
    _createResizer: function _createResizer() {
        var _this = this;

        var classNames = {
            handle: "mx_ResizeHandle",
            vertical: "mx_ResizeHandle_vertical",
            reverse: "mx_ResizeHandle_reverse"
        };
        var collapseConfig = {
            toggleSize: 260 - 50,
            onCollapsed: function onCollapsed(collapsed) {
                if (collapsed) {
                    _dispatcher2.default.dispatch({ action: "hide_left_panel" }, true);
                    window.localStorage.setItem("mx_lhs_size", '0');
                } else {
                    _dispatcher2.default.dispatch({ action: "show_left_panel" }, true);
                }
            },
            onResized: function onResized(size) {
                window.localStorage.setItem("mx_lhs_size", '' + size);
                _this.props.resizeNotifier.notifyLeftHandleResized();
            }
        };
        var resizer = new _resizer.Resizer(this.resizeContainer, _resizer.CollapseDistributor, collapseConfig);
        resizer.setClassNames(classNames);
        return resizer;
    },
    _loadResizerPreferences: function _loadResizerPreferences() {
        var lhsSize = window.localStorage.getItem("mx_lhs_size");
        if (lhsSize !== null) {
            lhsSize = parseInt(lhsSize, 10);
        } else {
            lhsSize = 350;
        }
        this.resizer.forHandleAt(0).resize(lhsSize);
    },


    onAccountData: function onAccountData(event) {
        if (event.getType() === "im.vector.web.settings") {
            this.setState({
                useCompactLayout: event.getContent().useCompactLayout
            });
        }
        if (event.getType() === "m.ignored_user_list") {
            _dispatcher2.default.dispatch({ action: "ignore_state_changed" });
        }
    },

    onSync: function onSync(syncState, oldSyncState, data) {
        var oldErrCode = this.state.syncErrorData && this.state.syncErrorData.error && this.state.syncErrorData.error.errcode;
        var newErrCode = data && data.error && data.error.errcode;
        if (syncState === oldSyncState && oldErrCode === newErrCode) return;

        if (syncState === 'ERROR') {
            this.setState({
                syncErrorData: data
            });
        } else {
            this.setState({
                syncErrorData: null
            });
        }

        if (oldSyncState === 'PREPARED' && syncState === 'SYNCING') {
            this._updateServerNoticeEvents();
        }
    },

    onRoomStateEvents: function onRoomStateEvents(ev, state) {
        var roomLists = _RoomListStore2.default.getRoomLists();
        if (roomLists['m.server_notice'] && roomLists['m.server_notice'].some(function (r) {
            return r.roomId === ev.getRoomId();
        })) {
            this._updateServerNoticeEvents();
        }
    },

    _updateServerNoticeEvents: function () {
        var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var _this2 = this;

            var roomLists, pinnedEvents, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, room, pinStateEvent, pinnedEventIds, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _loop, _iterator2, _step2;

            return _regenerator2.default.wrap(function _callee$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            roomLists = _RoomListStore2.default.getRoomLists();

                            if (roomLists['m.server_notice']) {
                                _context2.next = 3;
                                break;
                            }

                            return _context2.abrupt('return', []);

                        case 3:
                            pinnedEvents = [];
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 7;
                            _iterator = (0, _getIterator3.default)(roomLists['m.server_notice']);

                        case 9:
                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                                _context2.next = 43;
                                break;
                            }

                            room = _step.value;
                            pinStateEvent = room.currentState.getStateEvents("m.room.pinned_events", "");

                            if (!(!pinStateEvent || !pinStateEvent.getContent().pinned)) {
                                _context2.next = 14;
                                break;
                            }

                            return _context2.abrupt('continue', 40);

                        case 14:
                            pinnedEventIds = pinStateEvent.getContent().pinned.slice(0, MAX_PINNED_NOTICES_PER_ROOM);
                            _iteratorNormalCompletion2 = true;
                            _didIteratorError2 = false;
                            _iteratorError2 = undefined;
                            _context2.prev = 18;
                            _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop() {
                                var eventId, timeline, ev;
                                return _regenerator2.default.wrap(function _loop$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                eventId = _step2.value;
                                                _context.next = 3;
                                                return (0, _bluebird.resolve)(_this2._matrixClient.getEventTimeline(room.getUnfilteredTimelineSet(), eventId, 0));

                                            case 3:
                                                timeline = _context.sent;
                                                ev = timeline.getEvents().find(function (ev) {
                                                    return ev.getId() === eventId;
                                                });

                                                if (ev) pinnedEvents.push(ev);

                                            case 6:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _loop, _this2);
                            });
                            _iterator2 = (0, _getIterator3.default)(pinnedEventIds);

                        case 21:
                            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                                _context2.next = 26;
                                break;
                            }

                            return _context2.delegateYield(_loop(), 't0', 23);

                        case 23:
                            _iteratorNormalCompletion2 = true;
                            _context2.next = 21;
                            break;

                        case 26:
                            _context2.next = 32;
                            break;

                        case 28:
                            _context2.prev = 28;
                            _context2.t1 = _context2['catch'](18);
                            _didIteratorError2 = true;
                            _iteratorError2 = _context2.t1;

                        case 32:
                            _context2.prev = 32;
                            _context2.prev = 33;

                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }

                        case 35:
                            _context2.prev = 35;

                            if (!_didIteratorError2) {
                                _context2.next = 38;
                                break;
                            }

                            throw _iteratorError2;

                        case 38:
                            return _context2.finish(35);

                        case 39:
                            return _context2.finish(32);

                        case 40:
                            _iteratorNormalCompletion = true;
                            _context2.next = 9;
                            break;

                        case 43:
                            _context2.next = 49;
                            break;

                        case 45:
                            _context2.prev = 45;
                            _context2.t2 = _context2['catch'](7);
                            _didIteratorError = true;
                            _iteratorError = _context2.t2;

                        case 49:
                            _context2.prev = 49;
                            _context2.prev = 50;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 52:
                            _context2.prev = 52;

                            if (!_didIteratorError) {
                                _context2.next = 55;
                                break;
                            }

                            throw _iteratorError;

                        case 55:
                            return _context2.finish(52);

                        case 56:
                            return _context2.finish(49);

                        case 57:
                            this.setState({
                                serverNoticeEvents: pinnedEvents
                            });

                        case 58:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee, this, [[7, 45, 49, 57], [18, 28, 32, 40], [33,, 35, 39], [50,, 52, 56]]);
        }));

        function _updateServerNoticeEvents() {
            return _ref.apply(this, arguments);
        }

        return _updateServerNoticeEvents;
    }(),

    _onKeyDown: function _onKeyDown(ev) {
        /*
        // Remove this for now as ctrl+alt = alt-gr so this breaks keyboards which rely on alt-gr for numbers
        // Will need to find a better meta key if anyone actually cares about using this.
        if (ev.altKey && ev.ctrlKey && ev.keyCode > 48 && ev.keyCode < 58) {
            dis.dispatch({
                action: 'view_indexed_room',
                roomIndex: ev.keyCode - 49,
            });
            ev.stopPropagation();
            ev.preventDefault();
            return;
        }
        */

        var handled = false;
        var ctrlCmdOnly = (0, _Keyboard.isOnlyCtrlOrCmdKeyEvent)(ev);

        switch (ev.keyCode) {
            case _Keyboard.KeyCode.UP:
            case _Keyboard.KeyCode.DOWN:
                if (ev.altKey && !ev.shiftKey && !ev.ctrlKey && !ev.metaKey) {
                    var action = ev.keyCode == _Keyboard.KeyCode.UP ? 'view_prev_room' : 'view_next_room';
                    _dispatcher2.default.dispatch({ action: action });
                    handled = true;
                }
                break;

            case _Keyboard.KeyCode.PAGE_UP:
            case _Keyboard.KeyCode.PAGE_DOWN:
                if (!ev.ctrlKey && !ev.shiftKey && !ev.altKey && !ev.metaKey) {
                    this._onScrollKeyPressed(ev);
                    handled = true;
                }
                break;

            case _Keyboard.KeyCode.HOME:
            case _Keyboard.KeyCode.END:
                if (ev.ctrlKey && !ev.shiftKey && !ev.altKey && !ev.metaKey) {
                    this._onScrollKeyPressed(ev);
                    handled = true;
                }
                break;
            case _Keyboard.KeyCode.KEY_K:
                if (ctrlCmdOnly) {
                    _dispatcher2.default.dispatch({
                        action: 'focus_room_filter'
                    });
                    handled = true;
                }
                break;
            case _Keyboard.KeyCode.KEY_I:
                // Ideally this would be CTRL+P for "Profile", but that's
                // taken by the print dialog. CTRL+I for "Information"
                // will have to do.

                if (ctrlCmdOnly) {
                    _dispatcher2.default.dispatch({
                        action: 'toggle_top_left_menu'
                    });
                    handled = true;
                }
                break;
        }

        if (handled) {
            ev.stopPropagation();
            ev.preventDefault();
        }
    },

    /**
     * dispatch a page-up/page-down/etc to the appropriate component
     * @param {Object} ev The key event
     */
    _onScrollKeyPressed: function _onScrollKeyPressed(ev) {
        if (this.refs.roomView) {
            this.refs.roomView.handleScrollKey(ev);
        }
    },

    _onDragEnd: function _onDragEnd(result) {
        // Dragged to an invalid destination, not onto a droppable
        if (!result.destination) {
            return;
        }

        var dest = result.destination.droppableId;

        if (dest === 'tag-panel-droppable') {
            // Could be "GroupTile +groupId:domain"
            var draggableId = result.draggableId.split(' ').pop();

            // Dispatch synchronously so that the TagPanel receives an
            // optimistic update from TagOrderStore before the previous
            // state is shown.
            _dispatcher2.default.dispatch(_TagOrderActions2.default.moveTag(this._matrixClient, draggableId, result.destination.index), true);
        } else if (dest.startsWith('room-sub-list-droppable_')) {
            this._onRoomTileEndDrag(result);
        }
    },

    _onRoomTileEndDrag: function _onRoomTileEndDrag(result) {
        var newTag = result.destination.droppableId.split('_')[1];
        var prevTag = result.source.droppableId.split('_')[1];
        if (newTag === 'undefined') newTag = undefined;
        if (prevTag === 'undefined') prevTag = undefined;

        var roomId = result.draggableId.split('_')[1];

        var oldIndex = result.source.index;
        var newIndex = result.destination.index;

        _dispatcher2.default.dispatch(_RoomListActions2.default.tagRoom(this._matrixClient, this._matrixClient.getRoom(roomId), prevTag, newTag, oldIndex, newIndex), true);
    },

    _onMouseDown: function _onMouseDown(ev) {
        // When the panels are disabled, clicking on them results in a mouse event
        // which bubbles to certain elements in the tree. When this happens, close
        // any settings page that is currently open (user/room/group).
        if (this.props.leftDisabled && this.props.rightDisabled) {
            var targetClasses = new _set2.default(ev.target.className.split(' '));
            if (targetClasses.has('mx_MatrixChat') || targetClasses.has('mx_MatrixChat_middlePanel') || targetClasses.has('mx_RoomView')) {
                this.setState({
                    mouseDown: {
                        x: ev.pageX,
                        y: ev.pageY
                    }
                });
            }
        }
    },

    _onMouseUp: function _onMouseUp(ev) {
        if (!this.state.mouseDown) return;

        var deltaX = ev.pageX - this.state.mouseDown.x;
        var deltaY = ev.pageY - this.state.mouseDown.y;
        var distance = Math.sqrt(deltaX * deltaX + (deltaY + deltaY));
        var maxRadius = 5; // People shouldn't be straying too far, hopefully

        // Note: we track how far the user moved their mouse to help
        // combat against https://github.com/vector-im/riot-web/issues/7158

        if (distance < maxRadius) {
            // This is probably a real click, and not a drag
            _dispatcher2.default.dispatch({ action: 'close_settings' });
        }

        // Always clear the mouseDown state to ensure we don't accidentally
        // use stale values due to the mouseDown checks.
        this.setState({ mouseDown: null });
    },

    _setResizeContainerRef: function _setResizeContainerRef(div) {
        this.resizeContainer = div;
    },


    render: function render() {
        var LeftPanel = _index2.default.getComponent('structures.LeftPanel');
        var RoomView = _index2.default.getComponent('structures.RoomView');
        var UserView = _index2.default.getComponent('structures.UserView');
        var EmbeddedPage = _index2.default.getComponent('structures.EmbeddedPage');
        var GroupView = _index2.default.getComponent('structures.GroupView');
        var MyGroups = _index2.default.getComponent('structures.MyGroups');
        var MatrixToolbar = _index2.default.getComponent('globals.MatrixToolbar');
        var CookieBar = _index2.default.getComponent('globals.CookieBar');
        var NewVersionBar = _index2.default.getComponent('globals.NewVersionBar');
        var UpdateCheckBar = _index2.default.getComponent('globals.UpdateCheckBar');
        var PasswordNagBar = _index2.default.getComponent('globals.PasswordNagBar');
        var ServerLimitBar = _index2.default.getComponent('globals.ServerLimitBar');

        var pageElement = void 0;

        switch (this.props.page_type) {
            case _PageTypes2.default.RoomView:
                pageElement = _react2.default.createElement(RoomView, {
                    ref: 'roomView',
                    autoJoin: this.props.autoJoin,
                    onRegistered: this.props.onRegistered,
                    thirdPartyInvite: this.props.thirdPartyInvite,
                    oobData: this.props.roomOobData,
                    viaServers: this.props.viaServers,
                    eventPixelOffset: this.props.initialEventPixelOffset,
                    key: this.props.currentRoomId || 'roomview',
                    disabled: this.props.middleDisabled,
                    collapsedRhs: this.props.collapsedRhs,
                    ConferenceHandler: this.props.ConferenceHandler,
                    resizeNotifier: this.props.resizeNotifier
                });
                break;

            case _PageTypes2.default.MyGroups:
                pageElement = _react2.default.createElement(MyGroups, null);
                break;

            case _PageTypes2.default.RoomDirectory:
                // handled by MatrixChat for now
                break;

            case _PageTypes2.default.HomePage:
                {
                    var pageUrl = (0, _pages.getHomePageUrl)(this.props.config);
                    pageElement = _react2.default.createElement(EmbeddedPage, { className: 'mx_HomePage',
                        url: pageUrl,
                        scrollbar: true
                    });
                }
                break;

            case _PageTypes2.default.UserView:
                pageElement = _react2.default.createElement(UserView, { userId: this.props.currentUserId });
                break;
            case _PageTypes2.default.GroupView:
                pageElement = _react2.default.createElement(GroupView, {
                    groupId: this.props.currentGroupId,
                    isNew: this.props.currentGroupIsNew,
                    collapsedRhs: this.props.collapsedRhs
                });
                break;
        }

        var usageLimitEvent = this.state.serverNoticeEvents.find(function (e) {
            return e && e.getType() === 'm.room.message' && e.getContent()['server_notice_type'] === 'm.server_notice.usage_limit_reached';
        });

        var topBar = void 0;
        if (this.state.syncErrorData && this.state.syncErrorData.error.errcode === 'M_RESOURCE_LIMIT_EXCEEDED') {
            topBar = _react2.default.createElement(ServerLimitBar, { kind: 'hard',
                adminContact: this.state.syncErrorData.error.data.admin_contact,
                limitType: this.state.syncErrorData.error.data.limit_type
            });
        } else if (usageLimitEvent) {
            topBar = _react2.default.createElement(ServerLimitBar, { kind: 'soft',
                adminContact: usageLimitEvent.getContent().admin_contact,
                limitType: usageLimitEvent.getContent().limit_type
            });
        } else if (this.props.showCookieBar && this.props.config.piwik) {
            var policyUrl = this.props.config.piwik.policyUrl || null;
            topBar = _react2.default.createElement(CookieBar, { policyUrl: policyUrl });
        } else if (this.props.hasNewVersion) {
            topBar = _react2.default.createElement(NewVersionBar, { version: this.props.version, newVersion: this.props.newVersion,
                releaseNotes: this.props.newVersionReleaseNotes
            });
        } else if (this.props.checkingForUpdate) {
            topBar = _react2.default.createElement(UpdateCheckBar, this.props.checkingForUpdate);
        } else if (this.state.userHasGeneratedPassword) {
            topBar = _react2.default.createElement(PasswordNagBar, null);
        } else if (this.props.showNotifierToolbar) {
            topBar = _react2.default.createElement(MatrixToolbar, null);
        }

        var bodyClasses = 'mx_MatrixChat';
        if (topBar) {
            bodyClasses += ' mx_MatrixChat_toolbarShowing';
        }
        if (this.state.useCompactLayout) {
            bodyClasses += ' mx_MatrixChat_useCompactLayout';
        }

        return _react2.default.createElement(
            'div',
            { className: 'mx_MatrixChat_wrapper', 'aria-hidden': this.props.hideToSRUsers, onMouseDown: this._onMouseDown, onMouseUp: this._onMouseUp },
            topBar,
            _react2.default.createElement(
                _reactBeautifulDnd.DragDropContext,
                { onDragEnd: this._onDragEnd },
                _react2.default.createElement(
                    'div',
                    { ref: this._setResizeContainerRef, className: bodyClasses },
                    _react2.default.createElement(LeftPanel, {
                        resizeNotifier: this.props.resizeNotifier,
                        collapsed: this.props.collapseLhs || false,
                        disabled: this.props.leftDisabled
                    }),
                    _react2.default.createElement(_ResizeHandle2.default, null),
                    pageElement
                )
            )
        );
    }
});

exports.default = LoggedInView;
module.exports = exports['default'];
//# sourceMappingURL=LoggedInView.js.map